<section
    class="feature-card-grid"
    [ngClass]="{
        'feature-card-grid--cols-2': +block.data?.columnNumber === 2,
        'feature-card-grid--cols-3': +block.data?.columnNumber === 3,
        'feature-card-grid--cols-4': +block.data?.columnNumber === 4,
    }">
    @if (block.data.heading) {
        <h2 class="feature-card-grid__heading">{{ block.data.heading }}</h2>
    }

    @if (block.content.length > 0) {
        <div class="feature-card-grid__cards">
            @for (card of block.content; track card.id) {
                @if (card.data.heading) {
                    <div
                        class="feature-card"
                        [ngClass]="{
                            'feature-card--includes-image': card.data.image_url ? 'feature-card--includes-image' : '',
                            'feature-card--bg-primary': block.data.cardBgColor === 'primary',
                            'feature-card--bg-grey': block.data.cardBgColor === 'grey',
                            'feature-card--bg-white': block.data.cardBgColor === 'white',
                            'feature-card--no-shadow': block.data.cardDropshadow === '',
                        }">
                        @if (card.data.image_url) {
                            <img class="feature-card__image" [src]="parseImageUrl(card.data.image_url)" [alt]="" />
                        }

                        <div class="feature-card__content">
                            <h2 class="feature-card__heading">
                                {{ card.data.heading }}
                            </h2>

                            @if (card.data.description) {
                                <div class="feature-card__description" [innerHTML]="card.data.description"></div>
                            }

                            @if (card.data.includeCTA) {
                                @let cta = normalizeCta(card);
                                @if (isExternalLink(card)) {
                                    <a
                                        class="btn feature-card__cta"
                                        [class]="
                                            'feature-card__cta--' +
                                            cta.ctaVariant +
                                            ' ' +
                                            'feature-card__cta--' +
                                            cta.ctaTextColor +
                                            ' ' +
                                            'btn-' +
                                            cta.btnColor
                                        "
                                        [href]="card.data.ctaLink"
                                        [target]="card.data.isExternalLink ? '_target' : '_self'"
                                        [innerText]="card.data.ctaLabel"></a>
                                } @else {
                                    <a
                                        class="btn feature-card__cta"
                                        [class]="
                                            'feature-card__cta--' +
                                            cta.ctaVariant +
                                            ' ' +
                                            'feature-card__cta--' +
                                            cta.ctaTextColor +
                                            ' ' +
                                            'btn-' +
                                            cta.btnColor
                                        "
                                        [routerLink]="getRouterLink(card.data.ctaLink)"
                                        [target]="card.data.isExternalLink ? '_target' : '_self'"
                                        [innerText]="card.data.ctaLabel"></a>
                                }
                            }
                        </div>
                    </div>
                }
            }
        </div>
    }
</section>
